module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_1_1_2.c5a24a6d.png";